import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DataService } from '../services/dataService.service';

@Component({
  selector: 'app-newslist',
  templateUrl: './newslist.component.html',
  styleUrls: ['./newslist.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NewslistComponent implements OnInit {

    static componentName = 'NewslistComponent';
    news: any;

    constructor(
        private dataService: DataService,
    ) {}

    getPosts(): void {
        this.dataService.getPosts('post', false)
            .subscribe(res => this.convertPostsObject(res));
    }

    convertPostsObject(res): void {
        this.news = Object.keys(res).map(function(resNamedIndex) {
            return res[resNamedIndex];
        });
    }

    ngOnInit() {
        this.getPosts();
    }

}



// WEBPACK FOOTER //
// E:/MBP/BloomyNG/src/app/newslist/newslist.component.ts